<app-abstract-dialog [dialogWidth]="'600'">
    <ng-container abstract-header>
        <h3 class="abstract-dialog__header__title">{{dialogData.title}}</h3>
    </ng-container>

    <ng-container abstract-content>
        <div class="comment-dialog__content">
            <app-textarea cdkFocusInitial
                          [placeholder]="'CONSENT.COMMENTS.COMMENT_PLACEHOLDER' | translate"
                          [textValue]="value"
                          (emitInputEvent)="onInputChanged($event)">
            </app-textarea>
        </div>
    </ng-container>

    <ng-container abstract-footer>
        <app-button *ngIf="dialogData.comment === null"
                    [cssClasses]="'btn full-width solid__blue-07'"
                    [ariaLabel]="('CONSENT.COMMENTS.ADD_NEW_QUESTION' | translate) + ('GENERAL.BUTTON' | translate)"
                    (buttonClicked)="addNewComment(value)">
            {{'CONSENT.COMMENTS.ADD_NEW_QUESTION' | translate }}
        </app-button>

        <app-button *ngIf="dialogData.comment !== null"
                    [cssClasses]="'btn full-width solid__blue-07'"
                    [ariaLabel]="('GENERAL.SAVE' | translate) + ('GENERAL.BUTTON' | translate)"
                    (buttonClicked)="editComment(value)">
            {{'GENERAL.SAVE' | translate }}
        </app-button>
    </ng-container>
</app-abstract-dialog>
